module.exports = __webpack_public_path__ + "img/bapage-image.38d2b875.jpg";